import React from "react";

import {
  CustomBadges,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";

import "./index.scss";
import Context from "../../../../context";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const { setShowModal, setSelectedParent, requestParent } = React.useContext(
    Context.ParentScreen
  );

  function onClick(parent: any) {
    setSelectedParent!(parent);
    setShowModal!("SHOW_INFORMATION");
  }

  function onUpdate(parent: any) {
    setSelectedParent!(parent);
    setShowModal!("UPDATE");
  }

  function onRemoveArchive(parent: any) {
    setSelectedParent!(parent);
    setShowModal!("REMOVE_ARCHIVE");
  }

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const { t } = useTranslation();

  if (data?.length <= 0 || !data)
    return (
      <TableNullData
        text={
          requestParent?.search?.value?.length < 8 &&
          requestParent?.search?.value?.length > 1
            ? t("enter_phoneNumber_for_view_parent")
            : t("parents_were_not_found_with_this_number")
        }
      />
    );
  return (
    <tbody id="parent-table-body-container">
      {data?.map((parent: any, index: number) => {
        return (
          <tr key={`parent-${index}`}>
            <td className="pointer" onClick={() => onClick(parent)}>
              <UserInformation
                avatar={parent?.avatar}
                name={parent?.firstName}
                lastName={parent?.lastName}
                phoneNumber={parent?.phoneNumber}
                isBlock={parent?.blocks?.length >= 1}
              />
            </td>
            <td>
              <div className={'documents-approve-column'}>
                {parent?.parentInformation?.isArchived ?
                  (
                    <>
                      <CustomBadges type={'secondary-r'} title={'آرشیو شده'} />
                      <CustomIcon
                        icon="fas fa-box-open"
                        hoverTitle={t("removeArchive")}
                        onClick={() => onRemoveArchive(parent)}
                      />
                    </>
                  )
                    : parent?.parentInformation?.isNew ? <CustomBadges type={'warning'} title={'جدید'} />
                      : <CustomBadges type={'success'} title={'وفادار'} />}
              </div>
            </td>
            <td>
              {parent?.parentInformation?.province?.Name ? (
                <CustomBadges
                  title={parent?.parentInformation?.province?.Name}
                  type="primary"
                />
              ) : (
                ""
              )}
            </td>
            <td>
              {parent?.parentInformation?.city?.Name ? (
                <CustomBadges
                  title={parent?.parentInformation?.city?.Name}
                  type="primary"
                />
              ) : (
                ""
              )}
            </td>
            {/* actions */}
            <td>
              {writePermission === "true" && (
                <div className="table-actions-buttons">
                  {/* Edit Icon */}
                  <CustomIcon
                    icon="fas fa-pen"
                    hoverTitle={t("update")}
                    onClick={() => onUpdate(parent)}
                  />
                  {/* Delete Modal */}
                  {/* <CustomIcon icon="fas fa-trash" hoverTitle="حذف" onClick={() => onDelete(parent)} /> */}
                  {/* Block Icon */}
                  {/* <CustomIcon icon="fas fa-ban" hoverTitle="مسدود کردن" onClick={() => console.log("Block")} /> */}
                  {/* Block-Reason Icon */}
                  {/* {parent.blocks.length > 0 && (
                  <CustomIcon icon="fas fa-shield-xmark" hoverTitle="دلیل مسدودی" onClick={() => console.log("Reason")} />
                )} */}
                </div>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
